import classNames from 'classnames';
import { Button, Grid, LinearProgress, ListItemIcon, Menu, MenuItem, withStyles } from 'material-ui';
import ArrowDropDown from 'material-ui-icons/ArrowDropDown';
import BuildingIcon from 'material-ui-icons/List';
import LocationOn from 'material-ui-icons/Map';
import SortIcon from 'material-ui-icons/SortByAlpha';
import React from 'react';
import { translate } from 'react-i18next';
import { getAvailabilityDetails } from '../../services/availabilityService';
import InformationPanel from '../../ui/InformationPanel';
import Pagination from '../../ui/Pagination';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { getBackendFilters, getCheckedAppliedFilters, validateHistogramFilters, updateLandScapeForm } from '../Utils/FilterChangeFunctions';
import { filtersOptions } from './data/filterOptions';
import Filters from './Filters';
import ResultCard from './ResultCard';
import ResultMapContent from './ResultMapContent';
import ResultsBodyContent from './ResultsBodyContent';
import { connect } from 'react-redux';

import { getOnlineTotalPrice, scrollTo } from '../Utils/shared';
import { getFEClientName } from '../../services/serviceAPIHelper';
import { resetHotelsNew, results, cleanQuery, setParamsSearch, setFilters } from '../../actions/hotelsActions';
import { setHotelsTab } from '../../actions/tabActions';
import ReorderIcon from 'material-ui-icons/Reorder';
import { getAvailabilityWithParams } from '../SearchContent/CommonFunctions';
import topImage from '../../assets/arrow_circle_up-24px.svg';

const styles = theme => ({
    root: {
        backgroundColor: '#F5F5F5',
        color: '#616161',
    },
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: theme.spacing.unit * 2,
    },
    chip: {
        margin: theme.spacing.unit * 2,
        padding: 8,
    },
    mainResultsContainer: {
        width: '70%',
        minWidth: '950px',
        margin: '0 auto',
        paddingLeft: '2rem',
        paddingRight: '2rem',
    },
    sortLabel: {
        textColor: '#000000 !important',
    },
    sortingMenuList: {
        minWidth: '300px'
    },
    colorIcon: {
        color: theme.palette.primary.main,
    }
});

class Results extends OLYWebPageComponent {
    constructor(props) {

        super(props);
        this.cmsResultsRef = React.createRef();
        this.pageTitle = 'Resultados';
        this.pageName = 'Results';
        this.pageReference = 'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/653459479/UI+-+Resultados';

        this.mapComponent = React.createRef();

        const histoFilters = this.preprocessFilters(props.requestCode);
        this.props.dispatch(setFilters({histogram: histoFilters}));
        /**
         * USE DELATED SELECTION nos permite activar la multiple seleccion on un timeout de espera
         */
        this.USE_DELAYED_SELECTION = true;

        this.state = {
            anchorEl: null,
            showButtonScroll: false,
            data: [],
            query: {
                nights: 2,
                hotels: [],
                rooms: [],
                type: 'hotels', //transfers, exclusive, experience
                checkInDate: new Date(),

            },
            filters: histoFilters,
            requestObject: histoFilters.request,
            searchText: '',
            loading: true,
            sort: this.getTranslatedSortOptions()[4],
            totalCount: 0,
            total: 0,
            display: 0,
            currentPage: 0,
            isFiltered: false,
            mapVisible: false,
            listVisible: false,
            establishmentVisible: true,
            mapdata: [],
            hash: '',
            hotels: [],
            noResultsMsg: '',
            topImageSVG: topImage
        };

        this.onScroll();
    }

    async componentDidMount() {
        if (this.props && this.props.location) {
            try {


                // Store the current location for search by deeplinking
                this.props.dispatch(setParamsSearch(this.props.location.search));
                this.props.dispatch(setHotelsTab());

                const result = await getAvailabilityWithParams(this.props.location, this);
                if (result) {
                    window.location.href = '#/results/hotels/' + result.requestCode;
                } else {
                    this.setState({ loading: false });
                }
            } catch (error) {
                this.setState({ loading: false });
            }

        } else {
            localStorage.removeItem('redirectTo');
            this.__hashChanged();
        }
    }

    async componentWillReceiveProps(params) {
        const { hotelsNew, noResults } = params;
        if (hotelsNew) {
            this.__hashChanged();
            this.props.dispatch(results());
        }
        if (noResults && noResults.value) {
            this.setNoResultState(noResults);
        }
    }


    handleFault = error => {
        this.setNoResultState(error);
    }

    async setNoResultState(noResults) {
        await this.setState({
            anchorEl: null,
            data: [],
            query: {
                nights: 2,
                hotels: [],
                rooms: [],
                type: 'hotels', //transfers, exclusive, experience
                checkInDate: new Date(),
            },
            requestObject: {},
            searchText: '',
            loading: false,
            sort: this.getTranslatedSortOptions()[0],
            totalCount: 0,
            total: 0,
            display: 0,
            currentPage: 0,
            mapVisible: false,
            listVisible: false,
            establishmentVisible: true,
            mapdata: [],
            hash: '',
            hotels: [],
            noResultsMsg: noResults.message
        });
        localStorage.removeItem('redirectTo');
        this.props.dispatch(results());
        this.props.dispatch(cleanQuery());

    }

    preprocessFilters(requestCode) {
        let histogramResult = {};
        if (requestCode && localStorage.getItem(requestCode)) {
            histogramResult = JSON.parse(localStorage.getItem(requestCode));
        }
        return validateHistogramFilters(histogramResult);
    }


    onHashChanged = async hash => {
        if (hash && hash.parts && hash.parts.length > 1) {
            this.setState({ hash });
            const histoFilters = this.preprocessFilters(hash.parts[2]);
            const backendFilters = getBackendFilters(histoFilters);
            this.setState({ requestCode: hash.parts[2] });
            this.setState({ currentPage: 0 }, () => {
                this.refreshAvailability(backendFilters);
            });
            this.props.dispatch(resetHotelsNew());
        }
    };

    isFiltered = filters => {
        const appliedFilters = getCheckedAppliedFilters(this.props.filtersManager);
        //mayor a 1 porque onrequest siempre esta checked (a veces se manda t|f)
        return appliedFilters.total > 1;
    }

    isInViewport = (el) => {

        if ( !el ) {
            return false;
        }

        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    onScroll = () => {

        const rootElement = document.documentElement;

        document.addEventListener('scroll', () => {

            const scrollToTopBtn = document.querySelector('.topButton');

            if ( !scrollToTopBtn ) return;

            const scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
            const percentage = rootElement.scrollTop / scrollTotal;
            // 0.0075 este valor hará que el boton se muestre pasando el primer resultado al hacer scroll..
            percentage > 0.075 ? scrollToTopBtn.classList.add("showBtn") : scrollToTopBtn.classList.remove("showBtn");
        })
    }

    scrollButton = () => {
        const { anchorEl, topImageSVG} = this.state;
        const { t } = this.props;

        return <Button
            aria-owns={anchorEl ? 'simple-menu' : null}
            aria-haspopup="true"
            className="topButton"
            onClick={() =>  window.scrollTo({top: 0, behavior: 'smooth'})}>
            {t('RESULTS.GO_UP')}
            <img src={topImageSVG} style={{marginLeft: '5px'}} alt='' />
        </Button>
    }

    onFilterChange = (index, filterName, value) => {
        const filters = this.props.filtersManager;
        const mapVisible = this.state.mapVisible;
        let currentPageIndex = 0;
        if (!mapVisible) {
            //window.scrollTo(0, 0);
        }

        if (filterName != null && index != null) {
            switch (filterName) {
            case 'onrequest':
                //el filtro onrequest va siempre checked. (activo)
                filters[filterName][index].checked = true;
                filters[filterName][index].code = !filters[filterName][index].code;
                break;
            case 'hotelName':
                //el filtro hotelName va siempre checked. (activo)
                filters[filterName][index].checked = true;
                filters[filterName][index].code = value;
                break;
            case 'recommendedHotels':
                //el filtro onrequest va siempre checked. (activo)
                filters[filterName][index].checked = true;
                filters[filterName][index].code = !filters[filterName][index].code;
                break;
            case 'favoritesHotels':
                //el filtro onrequest va siempre checked. (activo)
                filters[filterName][index].checked = true;
                filters[filterName][index].code = !filters[filterName][index].code;
                break;    
            case 'available':
                //el filtro available va siempre checked. (activo)
                filters[filterName][index].checked = true;
                filters[filterName][index].code = !filters[filterName][index].code;
                break;
            case 'cardPrepaid':
                //el filtro prepaidCard va siempre checked. (activo)
                filters[filterName][index].checked = true;
                filters[filterName][index].code = !filters[filterName][index].code;
                break;
            default:
                filters[filterName][index].checked = !filters[filterName][index].checked;
                break;
            }
            //si cambio los filtros la pagina viene a cero.
            currentPageIndex = 0;
        }
        let isfiltered = this.isFiltered(filters);

        if (this.USE_DELAYED_SELECTION) {
            /*
            Esto te da un delay en la llamada asi podes esperar a que el usuario aplico todos los filtros.
            */
            this.setState({
                isFiltered: isfiltered,
                currentPage: currentPageIndex
            }
            );
            if (this.to) {
                clearTimeout(this.to);
                this.to = null;
            }
            this.to = setTimeout(() => this.delayedRefreshAvailability(), 1000);
        } else {
            this.setState({
                isFiltered: isfiltered,
                currentPage: currentPageIndex
            }, () => this.delayedRefreshAvailability());
        }
    }

    delayedRefreshAvailability = () => {
        const backendFilters = getBackendFilters(this.props.filtersManager);
        console.log('delayedRefreshAvailability');
        this.refreshAvailability(backendFilters);
    }

    refreshAvailability = (backendFilters) => {
        const sort = {};
        const mapVisible = this.state.mapVisible;
        let currentPageIndex = Math.max(0, this.state.currentPage);
        sort[this.state.sort.sortOn] = this.state.sort.sortBy;

        this.loadingStart();
        getAvailabilityDetails(this.getRequestCode(), mapVisible ? -1 : currentPageIndex, backendFilters, sort)
            .then(data => {
                this.props.dispatch(setFilters({histogram: data.histogram}));
                this.setResultDataProvider(data);
            }).catch(error => {
                if (error.errorType === 'CACHE_EXPIRED' && this.searchFormRegister && this.searchFormRegister.doSearch) {
                    this.searchFormRegister.doSearch();
                    return;
                }

                if (error.errorType === 'CACHE_EXPIRED') {
                    this.setState({ loading: false, expired: true });
                    return;
                }
            });
    }


    /*
    * El objeto data tiene la siguiente estructura
    {
        "prev": null,
        "current": 0,
        "next": 1,
        "last": 1,
        "totalCount": 11,
        "pageData": [Array de Hotels],
        "histogram": { objeto histograma}

    }
    */
    setResultDataProvider = (result) => {
        const mapVisible = this.state.mapVisible;
        if (result) {
            const dataProvider = result.pageData;
            const histogram = validateHistogramFilters(result.histogram);
            let totalPages = 0;
            let totalCount = histogram.total;
            if (result.pagination) {
                totalPages = parseInt(result.pagination.last.page, 10) + 1;
            }
            let isfiltered = this.isFiltered(histogram);
            updateLandScapeForm('result', result);

            if (mapVisible) {
                window.scrollTo(0, 0);
                this.setState({
                    loading: false,
                    query: result.query,
                    mapdata: dataProvider,
                    totalCount: totalCount,
                    filters: histogram,
                    isFiltered: isfiltered,
                    hotels: [],
                    noResultsMsg: ''
                });
            } else {

                this.setState({
                    loading: false,
                    query: result.query,
                    data: dataProvider,
                    lastPage: result.pagination.last,
                    display: totalPages <= 10 ? totalPages : 10,
                    currentPage: result.current ? result.current : 0,
                    total: totalPages,
                    totalCount: totalCount,
                    filters: histogram,
                    isFiltered: isfiltered,
                    noResultsMsg: ''
                });
            }
        }
    }

    onClearFilters = () => {
        if (!this.state.loading) {
            const histoFilters = this.preprocessFilters(this.props.requestCode);
            // Reset filters
            this.props.dispatch(setFilters({histogram: histoFilters}));
            if (histoFilters.onrequest) {
                histoFilters.onrequest.code = false;
            }
            const backendFilters = getBackendFilters(histoFilters);
            this.refreshAvailability(backendFilters);
        } else {
            alert('Please wait, we\'re processing your request');
        }
    }

    getRequestCode() {
        return this.state.requestCode ? this.state.requestCode : this.props.requestCode;
    }

    onSearchAgain = (data) => {
        try {
            this.setState({ expired: false });
            if (data && data.requestCode) {
                this.handleSearchAgain(data);
            } else {
                this.handleSearchAgain(null);
            }
        } catch (reason) {
            this.handleSearchAgain(reason);
        }
    }

    loadingStart = () => {
        this.setState({ loading: true });
    }

    loadingEnd = () => {
        this.setState({ loading: false });
    }

    resetPage = () => {
        this.setState({ currentPage: 0 });
    }

    searchContentParentHandler = (action, data) => {
        if (action === 'error') {
            this.setState({
                loading: false,
                totalCount: 0,
                data: [],
                backendmessage: data.message
            });
        }
        if (action === 'search') {
            this.setState({
                loading: true
            });
        }
        if (action === 'result') {
            this.setState({
                loading: false
            });
        }
    }

    handleSearchAgain = () => {
        //si tenemos esto debemos actualizar la pagina porque el usuario busco desde la barra minimizada.
        //console.log('handleSearchAgain > ' + histoFilters);
        //console.log(histoFilters);
    };

    openMenu = event => {
        this.setState({
            anchorEl: event.currentTarget,
        });
    };

    closeMenu = () => {
        this.setState({
            anchorEl: null,
        });
    };

    navigateToPage = data => {
        this.setState(
            {
                loading: true,
                currentPage: data.number - 1
            },
            () => {
                scrollTo(this.cmsResultsRef);
                this.delayedRefreshAvailability();
            },
        );
    };

    handleSortChange = item => {
        this.setState(
            {
                anchorEl: null,
                sort: item,
                loading: true,
            },
            () => {
                this.onFilterChange(null, null);
            },
        );
    };

    getTranslatedSortOptions = () => {
        return filtersOptions.map(option => {
            return {
                label: this.props.t(option.label),
                icon: option.icon,
                sortOn: option.sortOn,
                sortBy: option.sortBy
            };
        });
    }

    handleShowMap = (data) => {
        this.setState({
            mapVisible: data || !this.state.mapVisible,
            establishmentVisible: false,
            listVisible: false,
            hotels: this.state.mapVisible ? [] : this.state.hotels
        }, () => {
            if (this.state.totalCount > 0) {
                this.loadingStart();
                const backendFilters = getBackendFilters(this.props.filtersManager);
                this.refreshAvailability(backendFilters);
            }
        });
    }

    handleShowEstablishment = (data) => {
        this.setState({
            establishmentVisible: true,
            mapVisible: false,
            listVisible: false,
            hotels: this.state.mapVisible ? [] : this.state.hotels
        }, () => {
            if (this.state.totalCount > 0) {
                this.loadingStart();
                const backendFilters = getBackendFilters(this.props.filtersManager);
                this.refreshAvailability(backendFilters);
            }
        });
    }

    handleRemoveHotel = async (cardPosition) => {
        const newHotelList = this.state.hotels.filter((hotel, i) => i !== cardPosition);
        await this.setState({
            hotels: [...newHotelList]
        })
    }

    handleShowList = () => {
        this.setState({
            establishmentVisible: false,
            mapVisible: false,
            listVisible: true,
            hotels: this.state.mapVisible && this.state.totalCount > 0 ? [] : this.state.hotels
        }, () => {
            if (this.state.totalCount > 0) {
                this.loadingStart();
                const backendFilters = getBackendFilters(this.props.filtersManager);
                this.refreshAvailability(backendFilters);
            }
        });
    }

    onMarkerClick = async (hotel) => {
        if (!this.state.hotels.includes(hotel)) {
            await this.setState(prevState => ({
                hotels: [hotel, ...prevState.hotels]
            }));
        }
    }

    searchFormRegister = (comp) => {
        this.searchFormRegister = comp;
    }

    renderNumberOfHotels = () => {
        const { t } = this.props;
        const rest = 25 - this.state.data.length;
        // Mejorar esto con lógica más linda. Sry :D
        return (
            <div>
                {t('RESULTS.DISPLAYING_ESTABLISHMENT', {
                    partial: this.state.currentPage === 0 ? 1 : this.state.data.length === 25 ? ((this.state.data.length + 1) * this.state.currentPage) : ((this.state.data.length + rest) * this.state.currentPage) + 1,
                    totalPage: this.state.currentPage === 0 ? this.state.data.length  : this.state.data.length === 25 ? this.state.data.length * (this.state.currentPage + 1) : (this.state.data.length + rest) * (this.state.currentPage + 1) - rest,
                    total: this.state.totalCount })
                }
            </div>
        );
    }

    markAsFavorite = () => {
        this.onFilterChange(null,null,null);
    }

    loadingFavorite = () => {
        this.loadingStart();
    }

    renderResults = () => {
        if (this.state.establishmentVisible) {
            return (<div>
                <ResultsBodyContent
                    data={this.state.data}
                    nights={this.state.query.nights || 0}
                    query={this.state.query}
                    requestCode={this.props.requestCode}
                    onMarkAsFavorite={this.markAsFavorite}
                    loading={this.state.loading}
                    onLoadingFavorite={this.loadingFavorite}
                    listMode={this.state.listVisible}
                />
                {!!this.state.total && <div className="centercontent">
                    <Pagination
                        total={this.state.total}
                        current={this.state.currentPage + 1}
                        display={this.state.display}
                        onChange={number => this.navigateToPage({ number })}
                        colorAux={{ backgroundColor: '#ff0000' }}
                    />
                    {this.renderNumberOfHotels()}
                </div>}
                {(this.state.expired && !this.state.loading && this.state.data.length === 0) && <div id="expired" className="centercontent">
                    {this.props.t('RESULTS.EXPIRED')}
                </div>}
                {(this.state.totalCount === 0 && !this.state.expired && !this.state.loading && this.state.data.length === 0) &&
                    <div id="expired" className="centercontent" style={{ display: 'flex', justifyContent: 'center' }}>
                        {this.state.noResultsMsg}
                    </div>}
            </div>);
        } else if (this.state.listVisible) {
            return (<div className="cmsResultList">
                <ResultsBodyContent
                    data={this.state.data}
                    nights={this.state.query.nights || 0}
                    query={this.state.query}
                    requestCode={this.props.requestCode}
                    onMarkAsFavorite={this.markAsFavorite}
                    loading={this.state.loading}
                    listMode={this.state.listVisible}
                    onLoadingFavorite={this.loadingFavorite}
                />
                {!!this.state.total && <div className="centercontent">
                    <Pagination
                        total={this.state.total}
                        current={this.state.currentPage + 1}
                        display={this.state.display}
                        onChange={number => this.navigateToPage({ number })}
                        colorAux={{ backgroundColor: '#ff0000' }}
                    />
                    {this.renderNumberOfHotels()}
                </div>}
                {(this.state.expired && !this.state.loading && this.state.data.length === 0) && <div id="expired" className="centercontent">
                    {this.props.t('RESULTS.EXPIRED')}
                </div>}
                {(this.state.totalCount === 0 && !this.state.expired && !this.state.loading && this.state.data.length === 0) &&
                    <div id="expired" className="centercontent" style={{ display: 'flex', justifyContent: 'center' }}>
                        {this.state.noResultsMsg}
                    </div>}
            </div>);
        } else if (this.state.mapVisible) {
            return (

                <div>
                    <ResultMapContent
                        hotels={this.state.mapdata}
                        currentUser={this.currentUser}
                        nights={this.state.query || 0}
                        onMarkerClick={this.onMarkerClick}
                        t={this.props.t} />
                    {this.state.hotels && this.state.hotels.length && this.state.totalCount > 0 ?
                        this.state.hotels.map((hotel, i) => (
                            <ResultCard
                                key={i}
                                cardPosition={i}
                                showCloseButton={true}
                                isShowingFromMap={true}
                                onRemoveHotel={this.handleRemoveHotel}
                                onMarkAsFavorite={this.markAsFavorite}
                                className="animate fadeInUp one"
                                isExpandedDefault={true}
                                nights={this.state.nights}
                                query={this.state.query}
                                requestCode={this.props.requestCode}
                                cardData={hotel}
                            />
                        )) : ''
                    }

                    {(this.state.totalCount === 0 && !this.state.expired && !this.state.loading && this.state.data.length === 0) &&
                        <div>
                            <div id="expired" className="centercontent" style={{ display: 'flex', justifyContent: 'center' }}>
                                {this.state.noResultsMsg}
                            </div>
                        </div>}
                </div>
            );
        }
    }

    render() {
        const { classes, t } = this.props;
        const { anchorEl } = this.state;

        const parsedTotal = parseInt(this.state.totalCount, 10);
        const totalResults = isNaN(parsedTotal) ? 0 : parsedTotal;

        const filterOptionsAux = this.getTranslatedSortOptions();
        const clientName = getFEClientName();
        const classButton = clientName === 'default' || clientName === 'B2BWebOlympia' ? ' active-olympia' : ' active';

        return (
            <div className='cmsResults' ref={this.cmsResultsRef}>
                <div className='cmsContainer'>
                    <div className={'searchbar'}>
                    </div>
                    <div className={'row'}>
                        <div className={this.state.loading ? 'column left blur' : 'column left'}>
                            <strong>{t('RESULTS.ESTABLISHMENT', { count: totalResults })}</strong>
                            {
                                this.props.filtersManager && <Filters
                                    parentHandler={this.onSearchAgain}
                                    filtersData={this.props.filtersManager}
                                    onFilterChange={this.onFilterChange}
                                    onClearFilters={this.onClearFilters}
                                    isFiltered={this.state.isFiltered}
                                    loadingStart={this.loadingStart}
                                    loadingEnd={this.loadingEnd}
                                    resetPage={this.resetPage}
                                />
                            }
                        </div>
                        <div className='column right'>
                            <Grid container>
                                <Grid container item xs={6}>
                                    {totalResults > 0 &&
                                        <Grid item>
                                            <strong>{t('RESULTS.SORT')}</strong>
                                        </Grid>
                                    }
                                    {totalResults > 0 &&
                                        <Grid item>
                                            <Button
                                                aria-owns={anchorEl ? 'simple-menu' : null}
                                                aria-haspopup="true"
                                                onClick={this.openMenu}
                                                style={{
                                                    backgroundColor: '#ffffff',
                                                    width: '100%',
                                                    position: 'relative',
                                                }}>
                                                <SortIcon
                                                    className={classNames(
                                                        classes.leftIcon,
                                                        classes.colorIcon,
                                                    )}
                                                />
                                                {this.state.sort.label}
                                                <ArrowDropDown
                                                    style={{
                                                        position: 'absolute',
                                                        right: 0,
                                                    }}
                                                />
                                            </Button>
                                            <Menu
                                                id="sort-menu"
                                                MenuListProps={{
                                                    className: classes.sortingMenuList,
                                                }}
                                                anchorEl={anchorEl}
                                                open={Boolean(anchorEl)}
                                                onClose={this.closeMenu}
                                            >
                                                {filterOptionsAux.map((filter, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        onClick={() => this.handleSortChange(filter)}
                                                        selected={index === 0}>
                                                        <ListItemIcon className={classes.icon}>
                                                            {filter.icon}
                                                        </ListItemIcon>
                                                        {t(filter.label)}
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid container justify={'flex-end'} item xs={6}>
                                    <Grid item>
                                        <strong className={{}}>{t('RESULTS.VIEW')}</strong>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            onClick={() => this.handleShowEstablishment(false)}
                                            disabled={this.state.establishmentVisible}
                                            className={this.state.establishmentVisible
                                                ? classButton
                                                : ''}>
                                            <BuildingIcon
                                                className={classNames(
                                                    classes.leftIcon,
                                                    classes.colorIcon,
                                                )}
                                            />
                                            {t('RESULTS.ESTABLISHMENT')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            onClick={() => this.handleShowList()}
                                            disabled={this.state.listVisible}
                                            className={this.state.listVisible
                                                ? classButton
                                                : ''}>
                                            <ReorderIcon
                                                className={classNames(
                                                    classes.leftIcon,
                                                    classes.colorIcon,
                                                )}
                                            />
                                            {t('RESULTS.LIST')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            aria-owns={anchorEl ? 'simple-menu' : null}
                                            aria-haspopup="true"
                                            onClick={() => this.handleShowMap(false)}
                                            disabled={this.state.mapVisible}
                                            className={this.state.mapVisible
                                                ? classButton
                                                : ''}>
                                            <LocationOn
                                                className={classNames(
                                                    classes.leftIcon,
                                                    classes.colorIcon,
                                                )}
                                            />
                                            {t('RESULTS.MAP_VIEW')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div style={{ marginLeft: 15 }}>
                                {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : <div style={{ height: '6.4px' }} />}
                                {(totalResults < 1 && !this.state.loading) && <InformationPanel
                                    type="warning"
                                    title={t('RESULTS.NO_RESULTS_TITLE')}
                                    text={this.state.backendmessage ? this.state.backendmessage : t('RESULTS.NO_RESULTS_MESSAGE')}
                                />}
                            </div>
                            {
                                this.renderResults()
                            }
                        </div>
                    </div>
                    {
                        this.scrollButton()
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        hotelsNew: state.hotelsRedux.hotelsNew,
        noResults: state.hotelsRedux.noResults,
        hash: state.hotelsRedux.hash,
        filtersManager: state.hotelsRedux.filters.histogram
    };
};


export default connect(mapStateToProps)(translate('translations')(withStyles(styles)(Results)));


// WEBPACK FOOTER //
// ./src/components/Results/Results.js